module.exports = __webpack_public_path__ + "img/auth.a1d77ebb.jpg";